export default __webpack_public_path__ + "static/media/Rancho.c80b7b02.webp";